export const DEFAULT_DATA_TIMEZONE = 'utc';

export const CALENDAR_CONTAINER_CLASS = 'calendar-container';
export const SHOWROUND_DATEPICKER_CLASS = 'showround-datepicker';
